export const achievementData = {
    bio : "Volunteering experience that shaped my professional journey.",
    achievements : [
        {
            id : 1,
            title : 'Data Clerk - IEBC',
            details: 'Used software to perform data entry and prepare correspondence. Developed and managed inventory supply list and equipment orders. Verified data against database information.',
            date: 'April 2022 - September 2022',
            field: 'Volunteering',
            image: 'https://images.unsplash.com/photo-1573141597928-403fcee0e056?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80'
        },
        {
            id : 2,
            title : 'Field Census Enumerator - KNBS',
            details: 'Interviewed residents in assigned areas to explain census purpose. Recorded information using smartphone kits. Maintained accurate records of houses worked and miles driven.',
            date: 'April 2019 - September 2019',
            field: 'Volunteering',
            image: 'https://images.credly.com/size/680x680/images/242902b5-f527-42ad-865e-977c9e1b5b58/image.png'
        },
    ]
}